module.exports = __webpack_public_path__ + "images/grupo_IDDrive_mobile.8f02bed5.png";